import appClient from '../../common/services/AppClient';
import { StartSessionResponse, SessionStates } from '../../common/services/types';
import { CustomSessionState, CustomSessionRuntimeData } from '../types';
import { endpoints } from '../../../config';

export default class CustomSessionService {
    getSessionState<TResponse>(sessionExtension: string, sessionId: string) {
        const url = endpoints.manageUrl + `iotaruntime/applications/sessions/${sessionId}/state`;
        return appClient.get<CustomSessionState<TResponse>>(url);
    }

    continueSession(sessionExtension: string, sessionId: string, action: string, inputs: CustomSessionRuntimeData) {
        const url = endpoints.manageUrl + `iotaruntime/applications/sessions/${sessionId}`;
        const values = Object.fromEntries(Object.entries(inputs).map(([id, entry]) => [id, entry.value]));
        return appClient.post(url, { inputs: values, action });
    }

    startSession(
        applicationId: string,
        packageId: string,
        parameters: Record<string, unknown> | null = null,
        replacesSessionId?: string
    ) {
        const url = endpoints.manageUrl + `iotaruntime/applications/${applicationId}/sessions/${packageId}`;
        return appClient.post<StartSessionResponse>(url, { parameters, replacesSessionId });
    }

    updateSession(sessionId: string, state: SessionStates) {
        const request = {
            id: sessionId,
            state: state
        };

        const url = endpoints.manageUrl + 'iotaruntime/applications/sessions';
        return appClient.update(url, request);
    }

    async getFileFromIotaTempStorage(filePath: string) {
        const url = `${endpoints.iotaUrl}files/download`;
        const resp = await appClient.post(url, { filePath }, 'blob');

        resp.map(data => {
            const blobURL = URL.createObjectURL(data as Blob);
            const tempLink = document.createElement('a');

            tempLink.style.display = 'none';
            tempLink.href = blobURL;
            tempLink.setAttribute('download', filePath.replace(/^.*[\\/]/, ''));

            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank');
            }

            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);

            setTimeout(() => {
                URL.revokeObjectURL(blobURL);
            }, 100);
        });
    }
}
